import { MessageView } from "~/backendApis/viewModel"

export const messageDecorator = (view: MessageView) => ({
  get isSystemMessage(): boolean {
    return view.senderType === "system"
  },
  get isReportMatchingSystemMessage(): boolean {
    return view.senderType === "system" && view.type === "report_matching"
  },
  get isFileMessage(): boolean {
    if (view.fileName != null && view.filePath != null) {
      return true
    }
    return false
  },
})
